/**
 * 通用的答题记录列表组件，包括某次答题记录页面和错题集页面，都渲染这个组件
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import { useBrowserTitle } from 'hook/index';
import { Item, ItemView } from './Item';
import { RECENT_RECORD_DAYS, getRecentCutoffTsSec } from 'config/record';
import { getVideoTarget, buildVideoLink } from 'page/lesson/List/videoMapping';
import { BlockEmpty, BlockLoading } from 'component/BlockLoading/BlockLoading';
import styles from './ExerciseRecordList.module.scss';

export interface BackendData {
    list: Item[];
    skill: {
        // 技能中文名
        appNameCh: string;
    };
  isVip?: boolean;
}

interface Props {
    loading: boolean;
    data: BackendData;
    pageTitleSuffix?: string;
    // 统计条样式：detail=做题详情(对/错明细)，wrong=错题记录(仅错题数)
    summaryMode?: 'detail' | 'wrong';
    // 题型英文名，用于关联视频讲解入口
    appName?: string;
}

export function ExerciseRecordList({loading, data, pageTitleSuffix = '答题记录', summaryMode = 'detail', appName}: Props) {
    const history = useHistory();
    let pageTitle = pageTitleSuffix;
    if (data.skill && data.skill.appNameCh) {
        pageTitle = `${data.skill.appNameCh}-${pageTitleSuffix}`;
    }
    useBrowserTitle(pageTitle);

    const videoTarget = appName ? getVideoTarget(appName) : null;
    const skillName = (data.skill && data.skill.appNameCh) || '本题型';
    function goVideo() {
        if (videoTarget) {
            history.push(buildVideoLink(videoTarget));
        }
    }

    // 仅展示最近 RECENT_RECORD_DAYS 天的记录
    const cutoff = getRecentCutoffTsSec();
    const list = (data.list || []).filter(function(item){
        return item.create_time >= cutoff;
    });
    const total = list.length;
    const correctNum = list.filter(function(item){
        return item.is_right === 1 && !!item.answer_user;
    }).length;
    const wrongNum = total - correctNum;

    let content = null;
    if (!loading) {
        if (total < 1) {
            content = (<BlockEmpty/>);
        } else {
            content = (
                <div className={styles.page}>
                    {
                        videoTarget && (
                            <div className={styles.videoBanner} onClick={goVideo}>
                                <div className={styles.vbIcon}><span className={styles.vbTri}></span></div>
                                <div className={styles.vbText}>
                                    <div className={styles.vbT1}>没搞懂？看「{skillName}」视频讲解</div>
                                    <div className={styles.vbT2}>{videoTarget.series} · 精选讲解视频</div>
                                </div>
                                <span className={styles.vbChev}>&gt;</span>
                            </div>
                        )
                    }
                    <div className={styles.summary}>
                        <span className={styles.chip}>近 {RECENT_RECORD_DAYS} 天</span>
                        {
                            summaryMode === 'wrong'
                                ? (<span>错题 共 <span className={styles.statErr}>{total}</span> 道</span>)
                                : (<span>共 {total} 题 · 对 <span className={styles.statOk}>{correctNum}</span> · 错 <span className={styles.statErr}>{wrongNum}</span></span>)
                        }
                    </div>
                    {
                        list.map(function(obj: Item, index: number){
                            return (<ItemView key={index} item={obj} />);
                        })
                    }
                </div>
            );
        }
    }
    return (
        <div>
            { loading && <BlockLoading />}
            { content }
        </div>
    );
}
